import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import {
  SvgAnalyticsBarsBold,
  DetailsHeader,
} from '@insights-ltd/design-library/components';

import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import { ExportTransactions } from './ExportTransactions';

export const TransactionsSection = ({
  practitionerId,
}: {
  practitionerId: string;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <DetailsHeader
        Icon={SvgAnalyticsBarsBold}
        text={t('ui.event-management.my-account.transactions')}
        id="transaction-info"
        sx={{
          width: '100%',
          marginBottom: spacingSizeMap.S,
        }}
      />
      <ExportTransactions practitionerId={practitionerId} />
      <Box
        sx={{
          mb: '40px',
        }}
      />
    </>
  );
};

export default TransactionsSection;
